import { ASSIGN_BUYER_URL, ASSIGN_LISTING_BUYER_URL, BROWSE_TASK_SEARCH_BUYER_URL, BROWSE_TASK_SEARCH_URL, CANCEL_TASK_SELLER_URL, COMPLETED_LISTING_BUYER_URL, COMPLETE_BUYER_URL, FAQ_LIST_URL, MAKE_AN_OFFER_URL, MY_TASK_LIST_SELLER_URL, MY_TASK_LIST_URL, MY_TASK_SINGLE_URL, OFFER_LISTING_BUYER_URL, OFFER_LISTING_SELLER_URL, POST_TASK_URL, RELEASE_BUYER_URL, SELLER_INFO_URL, TASK_CATEGORY_LIST_URL, TASK_REVIEW_BUYER_URL, TASK_REVIEW_SELLER_URL, TASK_REVIEW_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const postTask = (props) => onResponse => {
    try {
        axiosInstance.post(POST_TASK_URL, props.formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getTaskCategoryList = () => onResponse => {
    try {
        axiosInstance.get(TASK_CATEGORY_LIST_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getMyTaskList = (props) => onResponse => {
    try {
        axiosInstance.post(MY_TASK_LIST_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getMyTaskSingle = (task_details) => onResponse => {
    try {
        axiosInstance.get(MY_TASK_SINGLE_URL + '?task_details=' + task_details)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const getFaqList = () => onResponse => {
    try {
        axiosInstance.get(FAQ_LIST_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const getMyTaskListSeller = (props) => onResponse => {
    try {
        axiosInstance.post(MY_TASK_LIST_SELLER_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const getMakeAnOffer = (props) => onResponse => {
    try {
        axiosInstance.post(MAKE_AN_OFFER_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const browsetaskSearch = (search, sort_order, category, filterprice_from, filterprice_to) => onResponse => {

    if (!search) {
        search = ""
    }
    if (!sort_order) {
        sort_order = ""
    }
    if (!category) {
        category = ""
    }
    if (!filterprice_from) {
        filterprice_from = ""
    }
    if (!filterprice_to) {
        filterprice_to = ""
    }
    let url = BROWSE_TASK_SEARCH_URL + '?search=' + search + '&sort_order=' + sort_order + '&category=' + category + '&filterprice_from=' + filterprice_from + '&filterprice_to=' + filterprice_to
    // if (search && category) {
    //     url = BROWSE_TASK_SEARCH_URL + '?search=' + search + '&sort_order=' + sort_order + '&category=' + category + '&filterprice_from=' + filterprice_from + '&filterprice_to=' + filterprice_to
    //    
    // }
    // else if (search) {
    //     url = BROWSE_TASK_SEARCH_URL + '?search=' + search + '&sort_order=' + sort_order + '&filterprice_from=' + filterprice_from + '&filterprice_to=' + filterprice_to
    //    

    // }
    // else if (category) {
    //  
    //     url = BROWSE_TASK_SEARCH_URL + '?sort_order=' + sort_order + '&category=' + category + '&filterprice_from=' + filterprice_from + '&filterprice_to=' + filterprice_to

    // }

    try {
        axiosInstance.get(url)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const browsetaskSeller = (page, per_page) => onResponse => {

    try {
        axiosInstance.get(BROWSE_TASK_SEARCH_URL + '?page=' + page + '&per_page=' + per_page)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const opentaskSeller = (page, per_page) => onResponse => {

    try {
        axiosInstance.get(BROWSE_TASK_SEARCH_URL + '?page=' + page + '&per_page=' + per_page)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const browsetaskSearchBuyer = (search, page, per_page, category, status_object) => onResponse => {
    let url = BROWSE_TASK_SEARCH_BUYER_URL
    if (search && category && status_object) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?search=' + search + '&status_object=' + status_object + '&category=' + category

    }
    else if (search && category) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?search=' + search + '&category=' + category

    }
    else if (category && status_object) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?status_object=' + status_object + '&category=' + category

    }
    else if (search && status_object) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?search=' + search + '&status_object=' + status_object

    }
    else if (search) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?search=' + search


    }
    else if (category) {

        url = BROWSE_TASK_SEARCH_BUYER_URL + '?category=' + category

    }
    else if (status_object) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?status_object=' + status_object + '&page=' + page + '&per_page=' + per_page
    }
    try {
        axiosInstance.get(url)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const browsetaskBuyer = (page, per_page, category, status_object, search) => onResponse => {
    let url = BROWSE_TASK_SEARCH_BUYER_URL + '?page=' + page + '&per_page=' + per_page
    if (search && category) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?search=' + search + '&status_object=' + status_object + '&category=' + category

    }
    else if (search) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?search=' + search

    }
    else if (category) {

        url = BROWSE_TASK_SEARCH_BUYER_URL + '?category=' + category
    }
    else if (status_object) {
        url = BROWSE_TASK_SEARCH_BUYER_URL + '?status_object=' + status_object + '&page=' + page + '&per_page=' + per_page
    }
    try {
        axiosInstance.get(url)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};


export const getOfferBuyer = (task_details_id) => onResponse => {
    try {
        axiosInstance.get(OFFER_LISTING_BUYER_URL + '?task_details_id=' + task_details_id)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getOfferSeller = (task_details_id) => onResponse => {
    try {
        axiosInstance.get(OFFER_LISTING_SELLER_URL + '?task_details_id=' + task_details_id)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};


export const getAssignBuyer = (limit, offset) => onResponse => {
    try {
        axiosInstance.get(ASSIGN_LISTING_BUYER_URL, + '?limit=' + limit + '&offset=' + offset)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const AssignBuyer = (task_offer, task_details) => onResponse => {
    try {
        axiosInstance.post(ASSIGN_BUYER_URL, task_offer, task_details)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const getCompleteBuyer = (limit, offset) => onResponse => {
    try {
        axiosInstance.get(COMPLETED_LISTING_BUYER_URL, + '?limit=' + limit + '&offset=' + offset)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const CompleteBuyer = (task_details) => onResponse => {
    try {
        axiosInstance.post(COMPLETE_BUYER_URL, task_details)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};


export const ReleaseBuyer = (task_details) => onResponse => {
    try {
        axiosInstance.post(RELEASE_BUYER_URL, task_details)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const CancelTaskSeller = (task_details, cancel_reason) => onResponse => {
    try {
        axiosInstance.post(CANCEL_TASK_SELLER_URL, { task_details, cancel_reason })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSellerInfo = (task_details_id) => onResponse => {
    try {
        axiosInstance.get(SELLER_INFO_URL + '?task_details_id=' + task_details_id)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const taskReviewInfo = (rating, comment, task_details) => onResponse => {
    try {
        axiosInstance.post(TASK_REVIEW_URL, { rating, comment, task_details })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const taskReviewBuyer = (rating, comment, task_details) => onResponse => {
    try {
        axiosInstance.post(TASK_REVIEW_BUYER_URL, { rating, comment, task_details })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};